let speakToken = 0;
let pendingTimer: ReturnType<typeof setTimeout> | null = null;

export function speak(text: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined" || !window.speechSynthesis) {
      reject(new Error("Speech synthesis is not available in this browser."));
      return;
    }

    // Cancel any in-flight utterance + pending schedule (prevents double-talk).
    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
    window.speechSynthesis.cancel();

    const token = ++speakToken;

    const utter = new SpeechSynthesisUtterance(text);
    utter.rate = 1.02;
    utter.pitch = 1;
    utter.volume = 1;

    const voices = window.speechSynthesis.getVoices();
    const preferred =
      voices.find((v) =>
        /Samantha|Google US English|Jenny|Aria/i.test(v.name),
      ) ??
      voices.find((v) => v.lang.startsWith("en")) ??
      null;
    if (preferred) utter.voice = preferred;

    utter.onend = () => {
      if (token !== speakToken) return;
      resolve();
    };
    utter.onerror = (e) => {
      if (token !== speakToken) return;
      // Chrome fires "interrupted" when we cancel for a newer speak — ignore.
      if (e.error === "interrupted" || e.error === "canceled") {
        resolve();
        return;
      }
      reject(e.error ?? new Error("Speech failed"));
    };

    // Chrome needs a beat after cancel before a new speak sticks.
    pendingTimer = setTimeout(() => {
      pendingTimer = null;
      if (token !== speakToken) return;
      window.speechSynthesis.speak(utter);
    }, 60);
  });
}

export function cancelSpeech() {
  speakToken += 1;
  if (pendingTimer) {
    clearTimeout(pendingTimer);
    pendingTimer = null;
  }
  if (typeof window !== "undefined") {
    window.speechSynthesis?.cancel();
  }
}
